"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _emotionTheming = require("emotion-theming");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var OrderDeliveryIcon = function OrderDeliveryIcon(_ref) {
  var width = _ref.width,
    height = _ref.height,
    viewBox = _ref.viewBox;
  // Get theme dynamic
  var theme = (0, _emotionTheming.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "33",
    height: "33",
    fill: theme.colors.primary.dark,
    stroke: theme.colors.primary.dark
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "3",
    y: "3",
    width: "28",
    height: "28",
    fill: "white"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "16.5",
    y: "2.5",
    width: "2",
    height: "10",
    fill: theme.colors.primary.dark,
    stroke: theme.colors.primary.dark
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 36C35.4183 36 39 32.4183 39 28C39 23.5817 35.4183 20 31 20C26.5817 20 23 23.5817 23 28C23 32.4183 26.5817 36 31 36Z",
    fill: theme.colors.primary.dark,
    stroke: "white",
    strokeWidth: "2.5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    y: "0.282842",
    width: "0.415072",
    height: "5.81101",
    transform: "matrix(0.681434 0.68143 -0.681434 0.68143 34.7484 25.8176)",
    fill: "white",
    stroke: "white",
    strokeWidth: "0.415072"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    width: "4.1507",
    height: "0.778256",
    transform: "matrix(0.681435 0.681429 -0.681435 0.681429 28.5811 27.1768)",
    fill: "white"
  }));
};
OrderDeliveryIcon.defaultProps = {
  width: '41',
  height: '38',
  viewBox: '0 0 41 38'
};
OrderDeliveryIcon.propTypes = {
  /**
   * the width of the icon
   */
  width: _propTypes["default"].string,
  /**
   * the height of the icon
   */
  height: _propTypes["default"].string,
  /**
   * the viewbox of the svg that wraps the icon
   */
  viewBox: _propTypes["default"].string
};
var _default = exports["default"] = OrderDeliveryIcon;